module.exports = __webpack_public_path__ + "static/media/09_avatar_animal.f0f032f0.png";